import * as React from 'react';
import SuperCritical from 'lib/supercritical';
import { ReservationsListBaseView } from 'portcall/reservationslistbase/view';
import { ReservationsDashboardResponse } from 'data/models/ReservationsDashboardResponse';
import { ReservationsDashboard } from './model';

export const ReservationsDashboardView = SuperCritical(({ model: m } : { model : ReservationsDashboard }) =>
    <ReservationsListBaseView<ReservationsDashboardResponse> model={m} className="reservations-dashboard" />
);


// WEBPACK FOOTER //
// ./apps/portcall/reservationsdashboard/view.tsx